module.exports = __webpack_public_path__ + "root-c2082cbd/a32a22248dd97ef8b3269accc4557505.woff";